import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Address } from 'return-portal-ui/old-ui/types/Address';

import { AppThunk } from '../store';
import { requestUser } from '../utils/api/apiUser';

export interface UserData {
  _id: string;
  email: string;
  addresses: {
    _id: string;
    default: boolean;
    address: Address;
  }[];
  firstname: string;
  lastname: string;
}

const userInitialState: {
  data: UserData;
} = {
  data: {
    _id: '',
    email: '',
    firstname: '',
    lastname: '',
    addresses: [],
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    userLoaded(state, { payload }: PayloadAction<UserData>) {
      state.data = payload;
    },
  },
});

export const { userLoaded } = userSlice.actions;

export const refreshUser = (): AppThunk => async (dispatch) => {
  const userRes = await requestUser();

  dispatch(userLoaded(userRes.user));
};

export default userSlice.reducer;
